"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configure = exports.resource = exports.fetchBlob = exports.fetchText = exports.fetchJson = exports.fetchResponse = exports.originalFetch = exports.HTTPMethod = exports.HTTPAuthenticationScheme = exports.HTTPContentType = exports.FetchError = void 0;
/**
 * @file Provides fetch functions.
 */

const defaults_1 = require("./defaults");

Object.defineProperty(exports, "configure", {
  enumerable: true,
  get: function () {
    return defaults_1.setDefaultOptions;
  }
});

const fetch_error_1 = __importDefault(require("./fetch_error"));

exports.FetchError = fetch_error_1.default;

const prepare_fetch_arguments_1 = require("./prepare_fetch_arguments");

const types_1 = require("./types");

Object.defineProperty(exports, "HTTPAuthenticationScheme", {
  enumerable: true,
  get: function () {
    return types_1.HTTPAuthenticationScheme;
  }
});
Object.defineProperty(exports, "HTTPContentType", {
  enumerable: true,
  get: function () {
    return types_1.HTTPContentType;
  }
});
Object.defineProperty(exports, "HTTPMethod", {
  enumerable: true,
  get: function () {
    return types_1.HTTPMethod;
  }
});

async function originalFetch(url, options = {}) {
  return fetch(url, options);
}

exports.originalFetch = originalFetch;

async function fetchResponse(url, ...options) {
  const _ref = (0, prepare_fetch_arguments_1.prepareFetchArguments)(url, options),
        _ref2 = _slicedToArray(_ref, 2),
        fetchUrl = _ref2[0],
        fetchOptions = _ref2[1];

  let response;

  try {
    response = await originalFetch(fetchUrl, fetchOptions);

    if (response && response.status >= 100 && response.status <= 399) {
      return response;
    }
  } catch (error) {
    const e = error;
    throw new fetch_error_1.default(0, e.message, undefined, error);
  }

  const body = await response.text();
  throw new fetch_error_1.default(response.status, body, response);
}

exports.fetchResponse = fetchResponse;

async function fetchJson(url, ...options) {
  const response = await fetchResponse(url, ...(0, prepare_fetch_arguments_1.prepareJsonFetchArguments)(options));
  const json = await response.json();
  return json;
}

exports.fetchJson = fetchJson;

async function fetchText(url, ...options) {
  const response = await fetchResponse(url, ...options);
  return response.text();
}

exports.fetchText = fetchText;

async function fetchBlob(url, ...options) {
  const response = await fetchResponse(url, ...options);
  return response.blob();
}

exports.fetchBlob = fetchBlob;

function resource(baseUrlWithoutTrailingSlash, ...baseOptions) {
  function localFetch(relativePath, ...options) {
    const fullUrl = relativePath === '' ? baseUrlWithoutTrailingSlash : [baseUrlWithoutTrailingSlash, relativePath].join('/');
    return fetchJson(fullUrl, ...baseOptions, ...options);
  }

  const fetchResource = {
    index(query, ...options) {
      return localFetch('', ...options, {
        method: types_1.HTTPMethod.get,
        query
      });
    },

    show(id, ...options) {
      return localFetch(id.toString(), ...options, {
        method: types_1.HTTPMethod.get
      });
    },

    create(jsonData, ...options) {
      return localFetch('', ...options, {
        method: types_1.HTTPMethod.post,
        jsonData
      });
    },

    update(jsonData, ...options) {
      return localFetch(jsonData.id.toString(), ...options, {
        method: types_1.HTTPMethod.put,
        jsonData
      });
    },

    destroy(id, ...options) {
      return localFetch(id.toString(), ...options, {
        method: types_1.HTTPMethod.delete
      });
    },

    get(relativePath, ...options) {
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.get
      });
    },

    post(relativePath, jsonData, ...options) {
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.post,
        jsonData
      });
    },

    put(relativePath, jsonData, ...options) {
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.put,
        jsonData
      });
    },

    delete(relativePath, ...options) {
      return localFetch(relativePath, ...options, {
        method: types_1.HTTPMethod.delete
      });
    },

    fetch(relativePath, ...options) {
      return localFetch(relativePath, ...options);
    }

  };
  return fetchResource;
}

exports.resource = resource;